import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/loading.svg'


const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "title-4 text-center" }, "Etats négatifs", -1)
const _hoisted_3 = {
  key: 0,
  class: "errors"
}
const _hoisted_4 = { class: "form-content mt-1" }
const _hoisted_5 = { class: "form-fields" }
const _hoisted_6 = { class: "field form-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "field-header" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "naative-states-year" }, "Saison concernée")
], -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  class: "btn btn-primary mt-1",
  type: "submit"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Télécharger ")
const _hoisted_11 = {
  key: 1,
  class: "spinner"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "Spinner"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

import { request } from "@/domains/api/api";
import { useLoading } from "@/domains/app/loading";
import { useUser } from "@/domains/auth/user";
import { Department } from "@/domains/cruds/departments/departments";
import { User } from "@/domains/cruds/users/users";
import { ref } from "vue";
import { read as readXSLX, writeFile as writeXSLX } from "xlsx";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser();

const now = new Date();
const april = new Date(`${now.getUTCFullYear()}-04-01T00:00:00.000Z`);

const startOfSeason =
    now.getTime() < april.getTime()
        ? new Date(`${now.getUTCFullYear() - 1}-04-01T00:00:00.000Z`)
        : april;

const { loading, setLoading } = useLoading("users.negative-states");
const error = ref<string | null>(null);

const availableSeasons: { start: Date; end: Date }[] = [];
for (let i = 0; i < 5; i++) {
    const start = new Date(startOfSeason.getTime() - 31536000000 * i);
    const end = new Date(start.getTime() + 31536000000 - 1);
    availableSeasons.push({ start, end });
}
const selectedSeason = ref(availableSeasons[0]);

function download() {
    error.value = null;
    if (!user.value || loading.value) return;
    setLoading(true);

    request<{ data: { user: User & { department: Department } }[] }>(
        "negative-states",
        "get",
        () => null,
        {
            season: selectedSeason.value.start.toISOString(),
        }
    )
        .then((rs) => {
            if (!rs) return (error.value = "Aucune fiche trouvée");
            const csv =
                "Numéro d'adhérent,Nom,Prénom,Département,Email\n" +
                rs.data
                    .map((r) =>
                        [
                            r.user.member_num,
                            r.user.last_name,
                            r.user.first_name,
                            r.user.department.code,
                            r.user.email,
                        ].join(",")
                    )
                    .join("\n");
            const tmp = readXSLX(csv, { type: "string" });
            return writeXSLX(tmp, "etats-negatifs.xlsx", { type: "base64" });
        })
        .catch((e) => {
            console.log(e);
            error.value = "Une erreur est survenue";
        })
        .finally(() => setLoading(false));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form mb-1",
    action: "",
    onSubmit: _withModifiers(download, ["prevent"])
  }, [
    _hoisted_2,
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(error.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("select", {
            name: "naative-states-year",
            id: "naative-states-year",
            class: "field__widget",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSeason).value = $event))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableSeasons, (season) => {
              return _createElementVNode("option", {
                value: season,
                key: season.start.getTime()
              }, _toDisplayString(season.start.getFullYear()) + " - " + _toDisplayString(season.end.getFullYear()), 9, _hoisted_8)
            }), 64))
          ], 512), [
            [_vModelSelect, selectedSeason.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("button", _hoisted_9, [
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_10
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
    ])
  ], 40, _hoisted_1))
}
}

})